import {useState, useEffect} from 'react';
import Player from './components/Player/Player';

function App() {
  const [songs] = useState([
    {
      title: "Itna Na Mujhse Tu Pyaar Badha(Duet)",
      artist: "Lata Mangeshkar",
      img_src: "./images/itna.jpg",
      src: "./music/Itna_Na_Mujhse_Tu_Pyaar_Badha.mp3"
    },
    {
      title: "Inteha Ho Gayi Intezaar Ki",
      artist: "Kishore Kumar",
      img_src: "./images/intjar.jpg",
      src: "./music/Inteha_Ho_Gayi_Intezaar_Ki.mp3"
    },
    {
      title: "Deva Deva",
      artist: "Arijit Singh",
      img_src: "./images/deva.jpg",
      src: "./music/Deva_Deva.mp3"
    },
    {
      title: "Kya Mujhe Pyar Hai",
      artist: "K.K.",
      img_src: "./images/size_m.webp",
      src: "./music/Kya_Mujhe_Pyar.mp3"
    },
    {
      title: "52 Bars",
      artist: "Karan Aujila",
      img_src: "./images/52bar.jpg",
      src: "./music/52_bar.mp3"
    }
  ]);

  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const [nextSongIndex, setNextSongIndex] = useState(currentSongIndex +1);

  
   

  useEffect(() => {
    setNextSongIndex(() => {
      if (currentSongIndex + 1 > songs.length - 1) {
        return 0;
      } else {
        return currentSongIndex + 1;
      }
    });
  }, [currentSongIndex, songs.length]);

  return (
    <div className="App">
      <Player 
        currentSongIndex={currentSongIndex} 
        setCurrentSongIndex={setCurrentSongIndex} 
        nextSongIndex={nextSongIndex} 
        songs={songs}
      />

    


    </div>
  );
}


export default App;
